// extracted by mini-css-extract-plugin
export default {"spinnerOverlay":"spinner_spinnerOverlay__BbDUs","spinnerContainer":"spinner_spinnerContainer__SLzrJ","spin":"spinner_spin__zo8Zl"};